import type { assistant as en } from "../en/assistant";
import type { Messages } from "../types";

export const assistant: Messages<typeof en> = {
  title: "المساعد",
  subtitle: "اسأل عن حساباتك أو اطلب منه مهمة. يجهّز الإجراءات بانتظار موافقتك.",
  newChat: "محادثة جديدة",
  history: "المحادثات",
  noHistory: "لا توجد محادثات بعد",
  untitled: "محادثة جديدة",
  deleteChat: "حذف المحادثة",
  hello: "أهلاً {{name}}، كيف أقدر أساعدك؟",
  helloHint: "أقرأ صندوق الوارد والمنشورات والتحليلات، وأصوغ الردود وأجهّز الإجراءات الجماعية. لا يُرسل شيء دون موافقتك.",
  suggestions: {
    week: "لخّص لي أداء هذا الأسبوع",
    spam: "أخفِ التعليقات المزعجة لهذا الأسبوع",
    prices: "ردّ على أسئلة الأسعار بدون رد",
    bestTime: "متى أفضل وقت للنشر؟",
  },
  placeholder: "اسأل أي شيء أو صف مهمة…",
  send: "إرسال",
  stop: "إيقاف",
  dictate: "إملاء صوتي",
  dictating: "أستمع… اضغط للإيقاف",
  voiceMode: "الوضع الصوتي",
  you: "أنت",
  bot: "ملفك",
  thinking: "يفكّر…",
  copy: "نسخ",
  copied: "تم النسخ",
  retry: "أعد المحاولة",
  error: "تعذّر على المساعد الإجابة. أعد المحاولة.",
  disclaimer: "قد يخطئ الذكاء الاصطناعي. الإجراءات المجهّزة تنتظرك دائماً.",
  staged: {
    title: "إجراء مجهّز",
    waiting: "بانتظار موافقتك",
    approve: "موافقة",
    reject: "رفض",
    approved: "تمت الموافقة",
    rejected: "مرفوض",
    editDraft: "تعديل المسودة",
    kinds: {
      reply_public: "رد علني",
      reply_private: "رد خاص",
      send_message: "رسالة مباشرة",
      hide: "إخفاء",
      delete: "حذف",
      bulk: "إجراء جماعي",
    },
  },
  voice: {
    title: "تحدّث مع ملفك",
    back: "العودة للمحادثة",
    start: "اضغط على الكرة وابدأ الكلام",
    idle: "الميكروفون متوقف",
    listening: "أستمع…",
    listeningPtt: "أستمع… اترك الزر للإرسال",
    transcribing: "أفهم كلامك…",
    thinking: "أفكّر…",
    speaking: "أتحدث الآن: اضغط للمقاطعة",
    noSpeech: "لم أسمع شيئاً. اضغط على الكرة لتحاول مجدداً.",
    micDenied: "تم رفض الوصول إلى الميكروفون. اسمح به من إعدادات الموقع في المتصفح.",
    micMissing: "لا يوجد ميكروفون. يمكنك الكتابة بدلاً من ذلك.",
    typeInstead: "أو اكتب سؤالك…",
    settings: "إعدادات الصوت",
    handsFree: "بدون يدين",
    handsFreeHint: "يتوقف التسجيل وحده عندما تتوقف عن الكلام، ثم يستمع من جديد بعد الإجابة.",
    pushToTalk: "اضغط للتحدث",
    pushToTalkHint: "اضغط مطوّلاً على الكرة (أو زر المسافة) أثناء الكلام.",
    captions: "ترجمة فورية لكلامك",
    captionsHint: "يعرض كلامك أثناء الحديث باستخدام التعرّف المدمج في المتصفح.",
    captionsUnsupported: "متصفحك لا يدعم العرض الفوري؛ سيظهر كلامك بعد أن تنتهي.",
    speakAnswers: "قراءة الإجابات بصوت عالٍ",
    log: "المحادثة",
    emptyLog: "ستظهر أدوارك هنا.",
    holdSpace: "اضغط مطوّلاً على المسافة للتحدث",
    demoVoice: "صوت تجريبي: الكلام محاكى في وضع البيانات التجريبية.",
  },
};
